export const GETPANEL_REQUEST = "GETPANEL_REQUEST";
export const GETPANEL_SUCCESS = "GETPANEL_SUCCESS";
export const GETPANEL_FAIL = "GETPANEL_FAIL";

export const PUTPANEL_REQUEST = "PUTPANEL_REQUEST";
export const PUTPANEL_SUCCESS = "PUTPANEL_SUCCESS";
export const PUTPANEL_FAIL = "PUTPANEL_FAIL";

export const DELETEPANEL_REQUEST = "DELETEPANEL_REQUEST";
export const DELETEPANEL_SUCCESS = "DELETEPANEL_SUCCESS";
export const DELETEPANEL_FAIL = "DELETEPANEL_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_MESSAGE = "SET_MESSAGE";
